import { CometUserRoleType } from '@zg-rentals/rental-manager-env';

const userUtils = {
  isPostingPathAdmin(roleTypes: Array<CometUserRoleType> = []): boolean {
    if (roleTypes === null) {
      return false;
    }
    return roleTypes.includes(CometUserRoleType.POSTING_PATH_ADMIN);
  },
  isMultiFamilyCustomer(roleTypes: Array<CometUserRoleType> = []): boolean {
    if (roleTypes === null) {
      return false;
    }
    return roleTypes.includes(CometUserRoleType.MULTIFAMILY_CUSTOMER);
  },
};

export default userUtils;
